module.exports = __webpack_public_path__ + "static/media/tau.32d2c2d0.m4a";